// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

class AnnouncementBar extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host([loaded]) {
        max-height: var(--Announcement_Height);
      }
      @media (prefers-reduced-motion: no-preference) {
        :host([loaded]) {
          transition: max-height 0.3s ease, background-color 0.3s ease;
        }
      }
    `
  }

  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.els.body.element.offsetHeight}px`,
    )

    this.setAttribute('loaded', '')

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== 0)
    })

    if (this.els.slide.elements.length < 2) return

    this.interval = 0

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(this.els.slides.element, {
      selector: '.hd-AnnouncementBar_Item',
      loop: true,
      renderMode: 'custom',
      slideChanged: this.onSlideChanged,
      created: () => {
        this.autoplay(true)
      },
      dragStarted: () => {
        this.autoplay(false)
      },
      dragEnded: () => {
        this.autoplay(true)
      },
    })
  }

  autoplay (run) {
    clearInterval(this.interval)

    this.interval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, 3000)
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
